import { useAppSelector } from 'store/store-hooks';
import { useLocation, Path } from 'components/_hooks/use-router';
import { isNull } from 'components/app/_helpers/_app.helper';
import { useClipsSwitch } from 'components/app/_hooks/use-clips-switch';
import { useZoomCb } from 'components/app/_mediator/zoom/use-zoom-cb';
import { useSbCb } from 'components/app/storyboard/_mediator/use-sb-cb';

import { AppButton } from 'components/app/app-components/app-button/app-button';
import { ActionsPlay } from './actions-play';

export const ActionsClips = () => {
  const { path } = useLocation();
  const { sbSeekTo } = useSbCb();
  const { keepCursorInView } = useZoomCb();
  const { handleNextClip, handlePrevClip } = useClipsSwitch();
  const markers = useAppSelector((state) => state.editor.markers);
  const config = useAppSelector((state) => state.editor.storyConfig);

  const seekToStart = () => {
    if (!config || !markers) return;
    sbSeekTo(!isNull(config.startMarkerId) ? markers[config.startMarkerId] : 0);
    keepCursorInView();
  };

  const seekToEnd = () => {
    if (!config || !markers) return;
    if (!isNull(config.finishMarkerId)) sbSeekTo(markers[config.finishMarkerId]);
    else sbSeekTo(1, 'fraction');
    keepCursorInView();
  };

  return path === Path.storyboard ? (
    <>
      <ActionsPlay />
      <AppButton outlined onClick={seekToStart} tip="Seek to start of storyboard" tipPosition="bottom">
        {'<'} Start
      </AppButton>
      <AppButton outlined onClick={handlePrevClip} tip="Navigate to previous clip" tipPosition="bottom">
        {'<'} Clip
      </AppButton>
      <AppButton outlined onClick={handleNextClip} tip="Navigate to next clip" tipPosition="bottom">
        Clip {'>'}
      </AppButton>
      <AppButton outlined onClick={seekToEnd} tip="Seek to end of storyboard" tipPosition="bottom">
        End {'>'}
      </AppButton>
    </>
  ) : (
    <>
      <AppButton outlined onClick={handlePrevClip} tip="Navigate to previous highlight" tipPosition="bottom">
        {`<`} Highlight
      </AppButton>
      <AppButton outlined onClick={handleNextClip} tip="Navigate to next highlight" tipPosition="bottom">
        Highlight {`>`}
      </AppButton>
    </>
  );
};
